import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import {Sort} from '@angular/material/sort';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import { RestaurantServiceService } from '../../restaurant/restaurant-service.service';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
  private id;
  private Id;
  p = 1;
  uploadForm: FormGroup;
  Imagefile: string;

  private mealId;
  sortedData: any [];
  addCategorymodel: any = {};
  listOfRestaurantsCategory: any = {};
  spin = false;
  modalRef: BsModalRef;
  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private router: Router,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private restaurantServices: RestaurantServiceService

  ) { }

  ngOnInit() {
    this.getAllRestaurnatType();
    this.uploadForm = this.formBuilder.group({
      file: ['']
    });
  }
  onSubmit() {
    debugger;
      this.restaurantServices.CreateMealCategory(this.addCategorymodel).subscribe((Data: any) => {
        if (!Data.id) {
          this.toastr.success('Successfully Added');
          this.router.navigateByUrl('/mealCategory');
          this.addCategorymodel.Name = '';
          this.getAllRestaurnatType();
        }
      }, error => {
        this.toastr.error(error.error.Message);
      });
    }
    uploadFileInput(event, cityid) {
      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        this.uploadForm.get('file').setValue(file);
        this.Imagefile = file;
        const formData = new FormData();
        formData.append('File', this.uploadForm.get('file').value);
        formData.append('Id', cityid.toString());
        this.restaurantServices.uploadMealCategory(formData).subscribe((Data: any) => {
          this.toastr.success('Image Update');
          this.getAllRestaurnatType();
        });
      }
    }
  getAllRestaurnatType() {
    this.restaurantServices.getAllMealCategory().subscribe(Response => {
      this.listOfRestaurantsCategory = Response;

       this.sortedData = this.listOfRestaurantsCategory.slice();

    });
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }

  confirm(id): void {
    this.restaurantServices.DeleteMealCategory(id).subscribe(Response => {
      this.getAllRestaurnatType();
    });
    this.modalRef.hide();
  }

  decline(): void {
    this.modalRef.hide();
  }
  UpdateType(id) {
    this.router.navigateByUrl('/updateMealCategory/' + id);

  }
}
